import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import Customer from "../components/pages/customer/Customer";
import CustomerDetail from "../components/pages/customer/CustomerDetail";
import OrderConfirmation from "../components/pages/placeOrder/OrderConfirmation";
import Estimates from "../components/pages/customer/Estimates";
import CountertopCabinetQuantity from "../components/pages/customer/CountertopCabinetQuantity";
import CncOrderDetail from "../components/pages/existingOrders/CncOrderDetail";

// Remount OrderConfirmation when the order params change so navigating between
// orders (e.g. via Previous/Next) reloads the order data from scratch.
const OrderConfirmationRoute = () => {
  const { contactInfoId, unitId, jobNum } = useParams();
  return <OrderConfirmation key={`${contactInfoId}-${unitId}-${jobNum}`} />;
};

const CustomerRoute = () => {
  return (
    <Routes>
      <Route path="/customer-list" exact element={<Customer />} />
      <Route path="/customer-list/customer-detail/:id" exact element={<CustomerDetail />} />
      <Route path="/place-order/order-confirmation/contactInfoId=:contactInfoId/unitId=:unitId/jobNum=:jobNum" exact element={<OrderConfirmationRoute />} />
      <Route path="/place-order/order-confirmation/:contactInfoId/:unitId/:jobNum" exact element={<OrderConfirmationRoute />} />
      <Route path="/estimating-customer-info" exact element={<Customer />} />
      <Route path="/sale-customer-info" exact element={<Customer />} />
      <Route path="/new-customers-secured-info" exact element={<Customer />} />
      <Route path="/customer-list/customer-detail/estimates/:id" element={<Estimates />} />
      <Route path="/customer-list/customer-detail/estimates/:id/:dataType" element={<Estimates />} />
      <Route path="/customer-list/customer-detail/countertop-cabinet-quantity/:contactInfoId/:unitTypeId" element={<CountertopCabinetQuantity />} />
      <Route path="/customer-list/customer-detail/countertop-cabinet-quantity/:contactInfoId/:unitTypeId/:variantId" element={<CountertopCabinetQuantity />} />
      <Route path="/cnc-estimate/contactInfoId=:contactInfoId/unitId=:unitId/jobNum=:jobNum" exact element={<CncOrderDetail />} />
      {/* React Router v6 can't match the "key=:param" form above; this route actually serves
          /cnc-estimate/contactInfoId=1/unitId=2/jobNum=CC-1 (CncOrderDetail strips the "key=" prefixes). */}
      <Route path="/cnc-estimate/:contactInfoId/:unitId/:jobNum" exact element={<CncOrderDetail />} />
    </Routes>
  );
};

export default CustomerRoute;